import { Link } from '@tanstack/react-router'
import { signOut } from '#lib/auth'

const NAV_LINKS = [
  { to: '/admin' as const, label: 'Dashboard', exact: true },
  { to: '/admin/clips' as const, label: 'Video Clips', exact: false },
  { to: '/admin/users' as const, label: 'Users', exact: false },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-cream-50 flex">
      <aside className="w-56 flex-shrink-0 border-r border-cream-200 bg-white px-4 py-8 flex flex-col gap-1">
        <Link to="/" className="px-3 mb-6 block group">
          <span className="font-serif text-lg text-warm-gray-900 group-hover:text-terracotta-500 transition-colors">
            Fold & Flow
          </span>
          <p className="text-xs text-warm-gray-400 mt-0.5">Admin</p>
        </Link>
        {NAV_LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            activeOptions={{ exact: link.exact }}
            activeProps={{ className: 'bg-terracotta-400/10 text-terracotta-600 font-medium' }}
            inactiveProps={{ className: 'text-warm-gray-600 hover:bg-cream-100' }}
            className="px-3 py-2 rounded-xl text-sm transition-colors"
          >
            {link.label}
          </Link>
        ))}
        <div className="mt-auto">
          <button
            type="button"
            onClick={() => signOut()}
            className="w-full px-3 py-2 rounded-xl text-sm text-warm-gray-400 hover:text-warm-gray-600 hover:bg-cream-100 text-left transition-colors"
          >
            Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 p-10 overflow-y-auto">{children}</main>
    </div>
  )
}
